<template>
  <div v-if="question.isShow" class="question-item">
    <div class="question-title">
      <i v-if="question.tipColor == 1">
        <img src="./image/red.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 2">
        <img src="./image/yellow.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 3">
        <img src="./image/green.png" alt="">
      </i>
      <i v-if="question.isMust">*</i><span>第{{ question.serialNumber }}题：</span>{{ question.title }}
    </div>
    <div v-if="question.note" class="question-note">说明：{{ question.note }}</div>
    <div style="text-align: left;" v-if="question.timeConfigArr[0].withBingId">
      (规则：{{ getTimeConfigString(question.timeConfigArr) }})
    </div>
    <div class="qs-img-preview">
      <img :src="question.pictureUrl" alt="">
    </div>
    <div class="question-option">
      <div class="time-item">
        <div class="time-item-top">
          <!--<input @change="saveAnswer" placeholder="年" v-model="question.value[0].yearSelect" type="text">-->
          <!--<i>年</i>-->
          <!--<input @change="saveAnswer" placeholder="月" v-model="question.value[0].monthSelect" type="text">-->
          <!--<i>月</i>-->
          <!--<input @change="saveAnswer" placeholder="日" v-model="question.value[0].daySelect" type="text">-->
          <!--<i>日</i>-->
          <time-picker  :date="question.value[0]"></time-picker>
        </div>
        <div v-if="question.isTime" class="time-item-bottom">
          <el-input  placeholder="时" v-model="question.value[0].hourSelect" type="text"></el-input>
          <i>时</i>
          <el-input  placeholder="分" v-model="question.value[0].minuteSelect" type="text">
          </el-input>
          <i>分</i>
        </div>

      </div>
      <div style="width: 100%;" class="question-option" v-if="question.dateCycle">
        <!--<span>{{question.linkWord}}</span>-->
        <span>至</span>
        <!--<time-picker :isDateCycle="true" @changeHandler="changeHandler" :date="question.value[1]"></time-picker>-->
        <div class="time-item">
          <div class="time-item-top">
            <!--<input @change="saveAnswer" placeholder="年" v-model="question.value[1].yearSelect" type="text">-->
            <!--<i>年</i>-->
            <!--<input @change="saveAnswer" placeholder="月" v-model="question.value[1].monthSelect" type="text">-->
            <!--<i>月</i>-->
            <!--<input @change="saveAnswer" placeholder="日" v-model="question.value[1].daySelect" type="text">-->
            <!--<i>日</i>-->
            <time-picker :isDateCycle="true"  :date="question.value[1]"></time-picker>
          </div>
          <div v-if="question.isTime" class="time-item-bottom">
            <el-input placeholder="时" v-model="question.value[1].hourSelect" type="text">
            </el-input>
            <i>时</i>
            <el-input placeholder="分" v-model="question.value[1].minuteSelect" type="text">
            </el-input>
            <i>分</i>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timePicker from './dateTimePicker'
import {mapGetters} from "vuex";

export default {
  name: 'questionTimeSelect',
  props: {
    question: {required: true},
    patientId: {required: true},
    questionList: {required: true},

  },
  components: {
    timePicker
  },
  computed: {
    QsValue() {
      return this.question.options.filter(item => item.selected)
    },
    ...mapGetters([
      'currentPage'
    ])
  },
  created() {
    this.init()
  },
  beforeDestroy() {
    // console.log(this.currentPage, this.question.pageNumber);
    // if(this.$route.path == '/callPatient' && this.currentPage == this.question.pageNumber) {
    //   console.log('destory');
    //   this.deleteAnswer()
    // }
  },
  watch: {
    'question.isShow': {
      handler(val, oldVal) {
        if (!val && oldVal) {
          this.question.value = [{
            yearSelect: '',
            monthSelect: '',
            daySelect: '',
            hourSelect: '',
            minuteSelect: '',
          }, {
            yearSelect: '',
            monthSelect: '',
            daySelect: '',
            hourSelect: '',
            minuteSelect: '',
          }]
        }else {
          this.changeValue()
        }
      },
      deep: true,
      immediate: true
    },
    // 'question.value': {
    //     handler(val) {
    //         // console.log(val);
    //         // this.saveAnswer()
    //     },
    //     deep: true,
    //     immediate: true
    // }
    // 'question.isShow': {
    //   handler(val, oldVal) {
    //     if (!val && oldVal) {
    //       this.question.value = [{
    //         yearSelect: '',
    //         monthSelect: '',
    //         daySelect: '',
    //         hourSelect: '',
    //         minuteSelect: '',
    //       }, {
    //         yearSelect: '',
    //         monthSelect: '',
    //         daySelect: '',
    //         hourSelect: '',
    //         minuteSelect: '',
    //       }]
    //       this.deleteAnswer()
    //     } else {
    //       this.changeValue()
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // },
  },
  methods: {
    getPicture() {
      if (this.question.pictureUrl && this.question.pictureUrl.indexOf('http') == -1) {
        this.$store.dispatch('getPicture', {url: [this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
      }
    },
    init() {
      this.getAnswer()
      this.getPicture()
    },
    selectHandler(item) {
      if (item.disabled) {
        return false
      }
      item.selected = !item.selected
      this.question.value = item
      this.question.value = this.QsValue
      // this.saveAnswer()
    },
    getTimeConfigString(config) {
      var string = ''
      config.forEach(v => {
        var question = this.questionList.find(item => item.id == v.withBingId)
        string += `${this.getType(v.type)}第${question.serialNumber}题目`
      })
      return string
    },
    getType(type) {
      switch (type) {
        case 3:
          return '早于'
          break
        case 4:
          return '早于或等于'
          break
        case 1:
          return '晚于'
          break
        case 2:
          return '晚于或等于'
          break
      }
    },
    async checkIsFill() {
      var value
      if (this.question.isShow) {
        if (this.question.isMust) {
          value = await this.checkValue()
          return value
        } else {
          return true
        }
      } else {
        return true
      }
    },
    async checkValue() {
      return new Promise(resolve => {
        var res
        this.chekLimitRule()
            .then(async () => {
              if (this.question.dateCycle) {
                if (this.question.value[0].yearSelect && this.question.value[0].daySelect && this.question.value[0].monthSelect
                    && this.question.value[1].yearSelect && this.question.value[1].daySelect && this.question.value[1].monthSelect
                ) {
                  res = await this.checkValueRule()
                } else {
                  res = false
                }
                resolve(res)
              } else {
                if (this.question.value[0].yearSelect && this.question.value[0].daySelect && this.question.value[0].monthSelect) {
                  res = await this.checkValueRule()
                } else {
                  res = false
                }
                resolve(res)
              }
            })
      })
    },
    chekLimitRule() {
      return new Promise(resolve => {
        if (this.question.bingTimeId && this.question.bingTimeId.length) {
          this.question.bingTimeId.forEach(v => {
            var qs = this.questionList.find(item => item.id == v)
            var configObj = qs.timeConfigArr.find(item => item.withBingId == this.question.id)
            configObj.value = this.timeHandler(this.question.value[0])
            configObj['valueBefore'] = JSON.parse(JSON.stringify(this.question.value[0]))
          })
        }
        resolve()
      })
    },
    async checkValueRule() {
      var result = await this.chekValueRuleAsync()
      // console.log(result,result.findIndex(item => !item) == -1)
      return result.findIndex(item => !item) == -1
      // return !result.findIndex(item => !item) == -1
      // return result.find(item => item === false)
    },
    chekValueRuleAsync() {
      return new Promise(resolve => {
        if (this.question.timeConfigArr[0].withBingId != '') {
          var resultArr = []
          this.question.timeConfigArr.forEach((v) => {
            var questionValue = this.timeHandler(this.question.value[0])
            if (questionValue == -1 || v.value == -1) {
              resultArr.push(true)
            } else {
              if (v.valueBefore && v.valueBefore.yearSelect == '不清楚') {
                resultArr.push(true)
              } else if (v.valueBefore && v.valueBefore.monthSelect == '不清楚') {
                if (this.question.value[0].yearSelect == v.valueBefore.yearSelect) {
                  resultArr.push(true)
                } else {
                  if (v.type == 1) {
                    resultArr.push(this.question.value[0].yearSelect > v.valueBefore.yearSelect)
                  } else if (v.type == 2) {
                    resultArr.push(this.question.value[0].yearSelect >= v.valueBefore.yearSelect)
                  } else if (v.type == 3) {
                    resultArr.push(this.question.value[0].yearSelect < v.valueBefore.yearSelect)
                  } else if (v.type == 4) {
                    resultArr.push(this.question.value[0].yearSelect <= v.valueBefore.yearSelect)
                  }
                }
              } else if (v.valueBefore && v.valueBefore.daySelect == '不清楚') {
                if (this.question.value[0].yearSelect == v.valueBefore.yearSelect && this.question.value[0].monthSelect == v.valueBefore.monthSelect) {
                  resultArr.push(true)
                } else {
                  if (v.type == 1) {
                    resultArr.push(questionValue > v.value)
                  } else if (v.type == 2) {
                    resultArr.push(questionValue >= v.value)
                  } else if (v.type == 3) {
                    resultArr.push(questionValue < v.value)
                  } else if (v.type == 4) {
                    resultArr.push(questionValue <= v.value)
                  }
                }
              } else if (this.question.value[0].monthSelect == '不清楚') {
                var yearB = new Date(v.value).getFullYear()
                if (this.question.value[0].yearSelect == yearB) {
                  resultArr.push(true)
                } else {
                  if (v.type == 1) {
                    resultArr.push(this.question.value[0].yearSelect > yearB)
                  } else if (v.type == 2) {
                    resultArr.push(this.question.value[0].yearSelect >= yearB)
                  } else if (v.type == 3) {
                    resultArr.push(this.question.value[0].yearSelect < yearB)
                  } else if (v.type == 4) {
                    resultArr.push(this.question.value[0].yearSelect <= yearB)
                  }
                }
              } else if (this.question.value[0].daySelect == '不清楚') {
                var yearB = new Date(v.value).getFullYear()
                var monthB = new Date(v.value).getMonth() + 1
                if (this.question.value[0].yearSelect == yearB && this.question.value[0].monthSelect == monthB) {
                  resultArr.push(true)
                } else {
                  if (v.type == 1) {
                    resultArr.push(questionValue > v.value)
                  } else if (v.type == 2) {
                    resultArr.push(questionValue >= v.value)
                  } else if (v.type == 3) {
                    resultArr.push(questionValue < v.value)
                  } else if (v.type == 4) {
                    resultArr.push(questionValue <= v.value)
                  }
                }
              } else {
                if (v.type == 1) {
                  resultArr.push(questionValue > v.value)
                } else if (v.type == 2) {
                  resultArr.push(questionValue >= v.value)
                } else if (v.type == 3) {
                  resultArr.push(questionValue < v.value)
                } else if (v.type == 4) {
                  resultArr.push(questionValue <= v.value)
                }
              }

            }
          })
          resolve(resultArr)
        } else {
          resolve([true])
        }
      })

    },
    timeHandler(time) {
      /**
       *
       *  daySelect: 30
       hourSelect: ""
       minuteSelect: ""
       monthSelect: 3
       yearSelect: 2021
       */
      var _item = JSON.parse(JSON.stringify(time))
      if (_item.yearSelect == '不清楚') {
        return -1
      } else if (_item.monthSelect == '不清楚') {
        return new Date(`${_item.yearSelect}-01-01`).getTime()
      } else if (_item.monthSelect == '上半年') {
        return new Date(`${_item.yearSelect}-03-15`).getTime()
      } else if (_item.monthSelect == '下半年') {
        return new Date(`${_item.yearSelect}-09-15`).getTime()
      } else if (_item.daySelect == '不清楚') {
        return new Date(`${_item.yearSelect}-${_item.monthSelect}-01`).getTime()
      } else if (_item.yearSelect == '至今') {
        return new Date().getTime()
      } else {
        return new Date(`${_item.yearSelect}-${_item.monthSelect}-${_item.daySelect}`).getTime()
      }

    },
    getAnswer() {
      if (this.question.value && Object.prototype.toString.call(this.question.value) == "[object Array]") {
        this.question.value = this.question.value
      } else if ((this.question.answerInfo && this.question.answerInfo.indexOf('yearSelect') != -1)) {
        this.question.value = JSON.parse(this.question.answerInfo)
      } else {
        this.question.value = [{
          yearSelect: '',
          monthSelect: '',
          daySelect: '',
          hourSelect: '',
          minuteSelect: ''
        }, {
          yearSelect: '',
          monthSelect: '',
          daySelect: '',
          hourSelect: '',
          minuteSelect: ''
        }]
      }
    },
    saveAnswer() {
      this.changeValue()
      return new Promise(resolve => {
        var params = {
          operatorId: localStorage.getItem('huidrUserId'),
          questionInfo: this.question.id,
          questionnaireNewId: this.question.questionnaireNewId,
          answerInfo: JSON.stringify(this.question.value) || [{
            yearSelect: '',
            monthSelect: '',
            daySelect: '',
            hourSelect: '',
            minuteSelect: ''
          }, {
            yearSelect: '',
            monthSelect: '',
            daySelect: '',
            hourSelect: '',
            minuteSelect: ''
          }],
          id: this.question.patientAnswerInfoId || null,
          patientId: this.patientId,
          questionType: this.question.type || null,
        }
        if (this.$route.query.abnormal == '5') {
          params.isRecord = true
        } else {
          params.isRecord = false
        }
        if (this.question.patientAnswerInfoId) {
          this.$store.dispatch('updateQuestionAnswer', params)
              .then(() => {

                resolve()
              })
        } else {
          this.$store.dispatch('saveQuestionAnswer', params)
              .then((res) => {
                this.question.patientAnswerInfoId = res.retValue.id
                // this.question.patientAnswerInfoId = res.retValue.id

                resolve()
              })
        }
      })
    },
    changeValue() {
      if (this.question.bingTimeId && this.question.bingTimeId.length && this.question.value) {
        this.question.bingTimeId.forEach(v => {
          var qs = this.questionList.find(item => item.id == v)
          var configObj = qs.timeConfigArr.find(item => item.withBingId == this.question.id)
          configObj.value = this.timeHandler(this.question.value[0])
          configObj['valueBefore'] = JSON.parse(JSON.stringify(this.question.value[0]))
        })
      }
    },
    deleteAnswer() {
      var params = {
        questionNewId: this.question.questionnaireNewId,
        answerInfoId: this.question.patientAnswerInfoId || null,
      }
      if (this.question.patientAnswerInfoId) {
        this.$store.dispatch('deleteQuestionAnswer', params)
            .then(res => {
              if (res.status == 0) {
                this.question.patientAnswerInfoId = null
                this.question.value = null
                this.question.answerInfo = null
              } else {
              }
            })
      }

    }

  }
}
</script>
<style lang="scss" scoped>
@import "questionCommon";

.question-option {
  display: flex;
  flex-direction: column;

  .option-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .disabled {
      color: #ccc;
    }

    span {
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .option-other {
  }
}

.time-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .time-item-top, .time-item-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: .05rem;

    i {
      font-size: .12rem;
      font-style: normal;
      margin: .05rem;
    }

    input {
      width: 25%;
      border-radius: .05rem;
    }
  }


}

.time-list {
  display: flex;

}
</style>